import React, { Component } from "react";
import { FlatButton } from "material-ui";

class PublishForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourceUpload: {
        isPublishToCCH: false,
        expiryDate: "",
        portalReadOnlyModeFlg: "",
        selectedYear: "",
        userComment: "",
      },
    };
    console.log("props", this.props);
    // this.handleCheckBox = this.handleCheckBox.bind(this);
    // this.handleExpiryChange = this.handleExpiryChange.bind(this);
    // this.handlePorterReadOnlyChange = this.handlePorterReadOnlyChange.bind(this);
    // this.handleYearChange = this.handleYearChange.bind(this);
    // this.handleUserComment = this.handleUserComment.bind(this);
    this.handleInputData = this.handleInputData.bind(this);
  }

  handleInputData = () => {
    // console.log("does it comes here==")
    // console.log(this.props);
    // this.props.isResetData ? this.props.setSourceUpload(this.props.sourceUpload) :
    this.props.setSourceUpload(this.state.sourceUpload);
    console.log("Is coming in update component function");
  };

  componentDidUpdate() {
    if (this.props.sourceUpload != this.state.sourceUpload) {
      this.handleInputData();
    }
  }
  handleResetFormData = () => {
    console.log("inside reset publish form");
    this.setState({
      sourceUpload: {
        isPublishToCCH: false,
        expiryDate: "",
        portalReadOnlyModeFlg: "",
        selectedYear: "",
        userComment: "",
      },
    });
    console.log(this.state);
  };
  handleResetCall = () => {
    this.handleResetFormData();
    this.props.resetForm();
  };
  handleInputChange(newPartialInput) {
    this.setState((state) => ({
      ...state,
      sourceUpload: {
        ...state.sourceUpload,
        ...newPartialInput,
      },
    }));
  }
  // handleCheckBox (event) {
  //     this.setState({ isPublishToCCH: event.target.checked });
  // }

  // handleExpiryChange (event) {
  //     this.setState({ expiryDate: event.target.value });
  // }

  // handlePorterReadOnlyChange (event) {
  //     this.setState({ portalReadOnlyModeFlg: event.target.value });
  // }

  // handleYearChange (event) {
  //     this.setState({ selectedYear: event.target.value });
  // }

  // handleUserComment (event) {
  //     this.setState({ userComment: event.target.value});
  // }

  render() {
    const {
      isPublishToCCH,
      expiryDate,
      portalReadOnlyModeFlg,
      selectedYear,
      userComment,
    } = this.state.sourceUpload;
    const options = [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ];
    const years = [
      2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
    ];

    return (
      <form>
        <div style={{ marginLeft: "20px" }}>
          <input
            type="checkbox"
            value={isPublishToCCH}
            checked={isPublishToCCH}
            //defaultChecked={isPublishToCCH}
            onChange={(e) =>
              this.handleInputChange({
                isPublishToCCH: e.target.checked,
              })
            }
          />
          <label style={{ marginLeft: "5px" }}> Publish To CCH </label>

          <label style={{ marginLeft: "100px" }}>Expiry Date:</label>
          <input
            type="date"
            className="datePicker-Input"
            style={{ marginLeft: "5px" }}
            value={expiryDate}
            onChange={(e) =>
              this.handleInputChange({
                expiryDate: e.target.value,
              })
            }
          ></input>

          <label style={{ marginLeft: "100px" }}>
            Porter Read Only Mode Flag:
          </label>
          <select
            name="expiryDate-dropdown"
            value={portalReadOnlyModeFlg}
            onChange={(e) =>
              this.handleInputChange({
                portalReadOnlyModeFlg: e.target.value,
              })
            }
            style={{ width: "7rem", marginLeft: "5px" }}
          >
            <option value="">Select</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <label
            style={
              this.props.isEngagementLetter || this.props.is8879Uploader
                ? { display: "none" }
                : { marginLeft: "60px" }
            }
          >
            {" "}
            Publish Year:{" "}
          </label>
          <select
            style={
              this.props.isEngagementLetter || this.props.is8879Uploader
                ? { display: "none" }
                : { marginLeft: "5px", height: "25px", width: "75px" }
            }
            name="year-dropdown"
            value={selectedYear}
            onChange={(e) =>
              this.handleInputChange({
                selectedYear: e.target.value,
              })
            }
          >
            <option value="">Select</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <div style={{ float: "left", marginLeft: "20px", marginTop: "2rem" }}>
          <label style={{}}> User Comments: </label>
          <textarea
            type="text"
            style={{
              verticalAlign: "middle",
              marginLeft: "5px",
              textAlign: "left",
              height: "45px",
              width: "400px",
            }}
            onChange={(e) =>
              this.handleInputChange({
                userComment: e.target.value,
              })
            }
            value={userComment}
          />
        </div>
        <div
          style={{
            float: "right",
            marginTop: "5rem",
            position: "absolute",
            right: "30px",
          }}
        >
          <FlatButton
            className="flatButtonCls"
            onClick={() => this.handleResetCall()}
          >
            Reset
          </FlatButton>
          <FlatButton
            type="submit"
            disabled={!this.props.submitEnabled}
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onClick={(e) => this.props.submitForm(e)}
          >
            Submit
          </FlatButton>
        </div>
      </form>
    );
  }
}

export default PublishForm;



// WEBPACK FOOTER //
// ./app/components/PublishForm.js